const PRIMARY = "primary";
const GHOST = "ghost";
const DASHED = "dashed";
const LINK = "link";
const TEXT = "text";
const DEFAULT = "default";
const TERTIARY = "tertiary";

const BUTTON_TYPES = {
  PRIMARY,
  GHOST,
  DASHED,
  LINK,
  TEXT,
  DEFAULT,
  TERTIARY,
};

export default BUTTON_TYPES;
